const validate = (values = {}) => {
	const errors = {};

	if (!values.name) errors.name = "Informe nome do contrato";

	return errors;
};

export default validate;
